import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import Item from '../../components/itens/item';
import logoDc from '../../assets/images/logo-dc.png'


function OrgaosScreen() {
    return (
        <Fragment>
            <Head titulo="Órgãos da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <Item
                            titulo={"Secretarias"}
                            descricao={"Veja aqui os horários de funcionamento, os telefones de contato e atribuições de cada uma das secretarias do nosso município."}
                            awesome={"faLandmarkDome"}
                            link={"orgaos/secretarias"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Carta de Serviços ao Cidadão"}
                            descricao={"Veja aqui quais serviços cada secretaria presta e orientações de como solicitar cada um deles."}
                            awesome={"faScroll"}
                            link={"orgaos/carta"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades de Saúde"}
                            descricao={"Veja aqui todas unidades de saúde em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faHospital"}
                            link={"orgaos/locais/saude"}
                            key={3}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades Escolares"}
                            descricao={"Veja aqui todas unidades de educação em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faSchool"}
                            link={"orgaos/locais/educacao"}
                            key={4}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades de Assistência Social"}
                            descricao={"Veja aqui todas unidades de assistência social em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faHandsHoldingChild"}
                            link={"orgaos/locais/social"}
                            key={5}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Quadras e Centros Esportivos"}
                            descricao={"Veja aqui todas quadras e centros esportivos em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faFutbol"}
                            link={"orgaos/locais/esporte"}
                            key={6}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades Gerais"}
                            descricao={"Veja aqui as demais unidades de atendimento em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faMapLocationDot"}
                            link={"orgaos/locais"}
                            key={7}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Frota Municipal"}
                            descricao={"Veja aqui listagem de veículos que compõe a frota municipal"}
                            awesome={"faCar"}
                            link={"../transparencia/veiculos"}
                            key={8}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Defesa Civil"}
                            descricao={"Veja aqui todos planos de contingência e documentos relacionados à Defesa Civil de Macuco"}
                            img={logoDc}
                            link={"orgaos/defesacivil"}
                            key={9}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OrgaosScreen;